import { select } from 'redux-saga/effects';
import { RootState } from '../reducers';

export default function selectState<T>(selector: (s: RootState) => T): any {
  return select(selector);
}
